export const DMA_REPORT_ID = 'dma';
